export default __webpack_public_path__ + "static/media/garmin_logo.ee302f8b.png";